<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div
      v-if="optionModel.showTitle"
      class="text-center"
    >
      <h4>{{isAdd ? '添加积分兑换物品项' : '编辑积分兑换物品项'}}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form
        ref="dataModel"
        :rules="rules"
        :model="dataModel"
        label-width="120px"
      >
        <el-form-item
          label="物品名称"
          prop="itemName"
        >
          <el-input
            @change='onInputChange'
            placeholder="请输入物品名称"
            v-model="dataModel.itemName"
            class="input-width"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="兑换所需积分"
          prop="bonusPoint"
        >
          <el-input
            @change='onInputChange'
            placeholder="请输入兑换所需积分"
            v-model="dataModel.bonusPoint"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="!isAdd"
          label="状态"
        >
          <el-select
            @change='onInputChange'
            v-model="dataModel.isActive"
            placeholder="请选择状态"
          >
            <el-option
              key="0"
              label="启用"
              :value="true"
            ></el-option>
            <el-option
              key="1"
              label="停用"
              :value="false"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          :span="20"
          class="footer-left"
        >
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
        >
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="saveDataToServer"
          >{{isAdd ? '确认添加' : '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import {
  createBonusPointExchangeItemModel,
  saveBonusPointExchangeItem
} from "../../service/bonusPoint.service";

export default {
  props: {
    options: {
      showTitle: Boolean
    },
    data: {
      index: Number,
      item: Object
    }
  },
  data() {
    let validateBonusPoint = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);

      if (!isValid) message = "请输入正确的积分数值";

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isAdd: true,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      optionModel: {
        showTitle: false
      },
      dataModel: {
        index: -1,
        id: 0,
        itemName: null,
        bonusPoint: null,
        isActive: true
      },
      rules: {
        itemName: [
          {
            required: true,
            message: "请输入物品名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 20,
            message: "最大长度在为20个字符",
            trigger: "blur"
          }
        ],
        bonusPoint: [
          {
            required: true,
            message: "请输入积分数值",
            trigger: "blur"
          },
          {
            validator: validateBonusPoint,
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.showTitle = options.showTitle;
      } else {
        this.optionModel.showTitle = false;
      }
    },
    loadDataFromProps(data = this.data) {
      if (!!data) {
        this.dataModel.index = data.index;
      } else {
        this.dataModel.index = -1;
      }

      if (!!data && !!data.item && !!data.item.Id) {
        this.dataModel.index = data.index;
        this.dataModel.id = data.item.Id;
        this.dataModel.itemName = data.item.ItemName;
        this.dataModel.bonusPoint = data.item.BonusPoint;
        this.dataModel.isActive = data.item.IsActive;
      } else {
        this.dataModel.index = -1;
        this.dataModel.id = 0;
        this.dataModel.itemName = null;
        this.dataModel.bonusPoint = null;
        this.dataModel.isActive = true;
      }

      if (this.$refs["dataModel"]) this.$refs["dataModel"].clearValidate();

      if (this.dataModel.index >= 0) {
        this.isAdd = false;
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.isAdd = true;
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }
      this.showError = false;
      this.message = "";
    },
    async saveDataToServer() {
      let isValid = this.checkAllInputs(true);
      if (!isValid) return;

      this.submitBtnDisable = true;

      this.showError = false;
      this.errorMessage = "";
      let saveModel = this.getDataOut().item;
      let result = await saveBonusPointExchangeItem(saveModel);
      if (!!result && result.success) {
        this.$message({
          message: "保存成功",
          type: "success"
        });
        this.dataModel.id = result.data;
        this.triggerSaveSuccess();
        this.triggerClose();
      } else {
        this.errorMessage = !!result ? result.message : "未连接到服务器";
        this.showError = true;
      }

      this.submitBtnDisable = false;
    },
    checkAllInputs(onlyCheck = false) {
      let isValid = true;

      if (!this.$refs["dataModel"]) return false;

      this.$refs["dataModel"].validate(valid => {
        if (!valid) {
          isValid = false;
        }
      });

      if (onlyCheck) return isValid;

      this.submitBtnClass = isValid ? "primary" : "info";
      this.submitBtnDisable = !isValid;

      return isValid;
    },
    init() {
      this.loadOptionModelFromProps();
      this.loadDataFromProps();
    },
    onInputChange(value) {
      this.checkAllInputs();
    },
    getDataOut() {
      let item = createBonusPointExchangeItemModel();
      let bonusPoint = parseFloat(this.dataModel.bonusPoint);
      $.extend(true, item, {
        Id: this.dataModel.id,
        ItemName: this.dataModel.itemName,
        BonusPoint: bonusPoint,
        IsActive: this.dataModel.isActive,
        Active: this.dataModel.isActive ? "启用" : "停用"
      });

      let dataOut = {
        index: this.dataModel.index,
        item: item
      };

      return dataOut;
    },
    triggerSaveSuccess(id) {
      let dataOut = this.getDataOut();

      this.$emit("saveSuccess", dataOut);
    },
    triggerClose() {
      this.$emit("closeDialog");
    }
  },
  watch: {
    options: function(newVal) {
      this.loadOptionModelFromProps(newVal);
    },
    data: function(newVal) {
      this.loadDataFromProps(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bpeItemManagement/bpeItemEdit.vue